import { Controller } from "../ts/controller";
import { Logger } from "../ts/utils/logger";

export class DialogController<T> extends Controller {
    private _initialized: boolean = false;
    protected data: T | null = null;
    private _dialogId!: string;
    private _closeButtonId!: string;

    private _isOpen: boolean = false;
    protected get isOpen(): boolean {
        return this._isOpen;
    }

    constructor({
        logLabel,
        dialogId: backdropId,
        closeButtonId,
    }: {
        logLabel: string,
        dialogId: string,
        closeButtonId: string,
    }) {
        super({
            logLabel,
        });
        this._dialogId = backdropId;
        this._closeButtonId = closeButtonId;
    }

    protected initialize(): void {
        this.bindClick({
            elementId: this._closeButtonId,
            handler: this.close.bind(this),
        });
        this._initialized = true;
    }

    protected setDialogState(): void {
        this._setDialogVisibilityState();
    }

    private _setDialogVisibilityState(): void {
        const dialogBackdrop = this.getElementByIdOrWarn('dialog-backdrop');
        if (dialogBackdrop) {
            dialogBackdrop.style.display = this._isOpen ? "flex" : "none";
        }
        const dialogWrapper = this.getElementByIdOrWarn(this._dialogId);
        if (dialogWrapper) {
            dialogWrapper.style.display = this._isOpen ? "flex" : "none";
        }
    }

    /** Override this in subclasses to setState on open */
    protected onDialogOpened(): void { }

    /** Override this in subclasses to setState on open */
    protected onDialogClosed(): void { }

    public open(data: T) {
        if (!this._initialized) {
            Logger.error(
                this.logLabel,
                'Cannot open. Must call super.initialize() in subclass'
            );
            return;
        }
        this.data = data;
        this._isOpen = true;
        this.setDialogState();
        this.onDialogOpened();
        Logger.info(this.logLabel, 'Opened')
    }

    public close() {
        if (!this._initialized) {
            Logger.error(
                this.logLabel,
                'Cannot close. Must call super.initialize() in subclass'
            );
            return;
        }
        this.data = null;
        this._isOpen = false;
        this.setDialogState();
        this.onDialogClosed();
        Logger.info(this.logLabel, 'Closed')
    }
}